import { artAsset } from "./artAssets";
import type {
  CanvasArtworkImage,
  CanvasDimensions,
} from "../data/canvasArtworks";

export function resolveCanvasImageUrl(image: CanvasArtworkImage): string {
  return artAsset(image.file);
}

export function canvasImageUrls(work: { images: CanvasArtworkImage[] }): string[] {
  return work.images.map(resolveCanvasImageUrl);
}

export function primaryCanvasImageUrl(work: {
  images: CanvasArtworkImage[];
}): string {
  return resolveCanvasImageUrl(work.images[0]);
}

export function formatCanvasDimensions(
  dimensions: CanvasDimensions,
  lang: "en" | "he",
): string {
  const { widthCm, heightCm, depthCm } = dimensions;
  const unit = lang === "he" ? 'ס"מ' : "cm";
  return `${widthCm} × ${heightCm} × ${depthCm} ${unit}`;
}

/** Fixed display rate — update periodically; not live FX. */
export const USD_TO_ILS_DISPLAY_RATE = 3.7;

export type FormattedInvestmentPrice = {
  primary: string;
  /** Optional secondary line (e.g. currency reference). */
  secondary?: string;
};

function roundIlsForDisplay(priceUsd: number): number {
  const raw = priceUsd * USD_TO_ILS_DISPLAY_RATE;
  return Math.round(raw / 500) * 500;
}

function formatUsd(priceUsd: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(priceUsd);
}

function formatIls(priceIls: number): string {
  return new Intl.NumberFormat("he-IL", {
    style: "currency",
    currency: "ILS",
    maximumFractionDigits: 0,
  }).format(priceIls);
}

export function formatInvestmentPrice(
  priceUsd: number,
  lang: "en" | "he",
): FormattedInvestmentPrice {
  if (lang === "en") {
    return { primary: formatUsd(priceUsd) };
  }

  return {
    primary: formatIls(roundIlsForDisplay(priceUsd)),
  };
}
